import { Injectable } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';

/**
 * Native `<dialog>` modals render in the browser's top layer, which sits above
 * normal DOM content regardless of z-index. CDK's overlay container is a single
 * div appended to `<body>` by default, so it renders behind an open `<dialog>`.
 * Re-parent it into whichever `<dialog>` is currently open instead.
 */
@Injectable()
export class DialogAwareOverlayContainer extends OverlayContainer {
  override getContainerElement(): HTMLElement {
    const container = super.getContainerElement();
    const openDialog = this._document.querySelector('dialog[open]');
    const target = openDialog ?? this._document.body;

    if (container.parentElement !== target) {
      target.appendChild(container);
    }

    return container;
  }
}
